import type { MarketType, PriceStyle, SportType, TicketVoucherOptionStatus } from '@/interface/enum';

export interface IVoucherResponse {
    id: string;
    stake: number;
    expiryDate: string;
    currency: string;
}

export interface IVoucherInput {
    sportType: SportType;
    leagueId: number;
    minBet: number;
    maxBet: number;
    marketType: MarketType;
    price: number;
    priceStyle: PriceStyle | null;
}

export type VoucherUnavailableReason =
    | TicketVoucherOptionStatus.UnavailableOddsInvalid
    | TicketVoucherOptionStatus.UnavailableStakeRange;

export interface IVoucherDisplay extends IVoucher {
    isAvailable: boolean;
    unavailableReason: VoucherUnavailableReason | null;
    text: string;
}

export interface IVoucher {
    id: string;
    type: VoucherType;
    productType: SirenProductType;
    stake: number;
    expiryDate: string;
}

export enum VoucherType {
    Active = 1,
    Claimed = 2,
    Expired = 3,
    ToSplit = 100
}

export enum SirenProductType {
    Unknown = 0,
    SportsBook = 1,
    HorseRacing = 2,
    Games = 3,
    Casino = 4,
    RaceTote = 6,
    RoyalCasino = 7,
    KironGames = 8,
    EyeconGames = 9,
    CasinoGames = 10, // 0x0A
    FinancialBetting = 11, // 0x0B
    TableGames = 12, // 0x0C
    NYX = 13, // 0x0D
    PariplayGames = 14, // 0x0E
    PariplayBGames = 15, // 0x0F
    CeltonGames = 16, // 0x10
    Betradar = 17, // 0x11 Virtual Sports
    LiveDraw = 18, // 0x12
    PariplayPGames = 19, // 0x13
    SAGaming = 20, // 0x14
    Allanion = 21, // 0x15
    UltraEGaming = 22, // 0x16
    Terra = 23, // 0x17
    ESports = 24, // 0x18
    GamingWorld = 25, // 0x19
    Inplaymatrix = 26, // 0x1A
    TendaSoft = 27, // 0x1B
    SV388 = 28, // 0x1C
    RubyPlay = 29, // 0x1D
    PocketGames = 30, // 0x1E
    LiveShow = 31, // 0x1F
    TerraGGR = 32, // 0x20
    BestDistinction = 33, // 0x21
    RedPoint = 34, // 0x22
    Pragmaticplay = 35, // 0x23
    MuaySteps = 36, // 0x24
    B2B2C = 37, // 0x25
    Jacktime = 43, // 0x2B
}
